import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, type PathValue, useFormContext } from 'react-hook-form';
import Select from '../../select';
import type { Option, SelectProps } from '../../select/select.types';
import FormWrapper from '../internals/form-wrapper';
export type FormSelectProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  hint?: string;
  addon?: React.ReactNode;
  options: Option[];
  containerClassName?: string;
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal' | 'horizontal-justify-between';
  onChange?: (value: string) => void;
  value?: string;
  defaultValue?: string;
  hideError?: boolean;
} & Omit<SelectProps, 'value' | 'ref' | 'label' | 'hasError' | 'onChange'>;
export default function FormSelect(t0) {
  const $ = _c(36);
  let addon;
  let ariaLabel;
  let baseId;
  let defaultValue;
  let hint;
  let label;
  let name;
  let onChange;
  let options;
  let props;
  let rules;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t0) {
    ({
      rules,
      name,
      label,
      hint,
      addon,
      errorPosition: t1,
      orientation: t2,
      size: t3,
      id: baseId,
      onChange,
      defaultValue,
      options,
      "aria-label": ariaLabel,
      hideError: t4,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = addon;
    $[2] = ariaLabel;
    $[3] = baseId;
    $[4] = defaultValue;
    $[5] = hint;
    $[6] = label;
    $[7] = name;
    $[8] = onChange;
    $[9] = options;
    $[10] = props;
    $[11] = rules;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    addon = $[1];
    ariaLabel = $[2];
    baseId = $[3];
    defaultValue = $[4];
    hint = $[5];
    label = $[6];
    name = $[7];
    onChange = $[8];
    options = $[9];
    props = $[10];
    rules = $[11];
    t1 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
  }
  const errorPosition = t1 === undefined ? "relative" : t1;
  const orientation = t2 === undefined ? "vertical" : t2;
  const size = t3 === undefined ? "default" : t3;
  const hideError = t4 === undefined ? false : t4;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  const id = baseId || contextId;
  const t5 = defaultValue as PathValue<TFieldValues, Path<TFieldValues>>;
  let t6;
  if ($[16] !== addon || $[17] !== ariaLabel || $[18] !== defaultValue || $[19] !== errorPosition || $[20] !== hideError || $[21] !== hint || $[22] !== id || $[23] !== label || $[24] !== onChange || $[25] !== options || $[26] !== orientation || $[27] !== props || $[28] !== size) {
    t6 = t7 => {
      const {
        field,
        fieldState
      } = t7;
      const error = fieldState.error?.message;
      return <FormWrapper id={id} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} addon={addon} orientation={orientation} fullWidth={true} disabled={props.disabled || field.disabled} hideError={hideError}><Select {...props} {...field} aria-label={label ? null : ariaLabel} disabled={field.disabled || props.disabled} options={options} value={(props.value ?? field.value ?? defaultValue ?? "") as string} onChange={value => {
          field.onChange(value as PathValue<TFieldValues, Path<TFieldValues>>);
          onChange?.(value as string);
        }} onBlur={() => {
          field.onBlur();
          props.onBlur?.();
        }} hasError={!!error} id={id} size={size} data-dd-privacy="mask" className={cx({
          "[&_button]:!rounded-bl-none [&_button]:!rounded-tl-none": addon
        }, props.className)} /></FormWrapper>;
    };
    $[16] = addon;
    $[17] = ariaLabel;
    $[18] = defaultValue;
    $[19] = errorPosition;
    $[20] = hideError;
    $[21] = hint;
    $[22] = id;
    $[23] = label;
    $[24] = onChange;
    $[25] = options;
    $[26] = orientation;
    $[27] = props;
    $[28] = size;
    $[29] = t6;
  } else {
    t6 = $[29];
  }
  let t7;
  if ($[30] !== control || $[31] !== name || $[32] !== rules || $[33] !== t5 || $[34] !== t6) {
    t7 = <Controller control={control} name={name} rules={rules} defaultValue={t5} render={t6} />;
    $[30] = control;
    $[31] = name;
    $[32] = rules;
    $[33] = t5;
    $[34] = t6;
    $[35] = t7;
  } else {
    t7 = $[35];
  }
  return t7;
}